module.exports = __webpack_public_path__ + "media/application/images/svgs/phone-outgoing-d5085a125ea829cc6615ef3890524dfa.svg";